import { createSvgIcon } from './createSvgIcon.js';

// In fluentui-system-icons, this is "ArrowClockwiseFilled"
export const Refresh20 = createSvgIcon(
  'Refresh20',
  20,
  'M4 10C4 6.68629 6.68629 4 10 4C11.5213 4 12.9107 4.56592 13.9689 5.5H12.75C12.3358 5.5 12 5.83579 12 6.25C12 6.66421 12.3358 7 12.75 7H15.75C16.1642 7 16.5 6.66421 16.5 6.25V3.25C16.5 2.83579 16.1642 2.5 15.75 2.5C15.3358 2.5 15 2.83579 15 3.25V4.40987C13.6736 3.22274 11.9213 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 9.90715 17.4983 9.81467 17.495 9.72258C17.4799 9.30864 17.1321 8.9853 16.7181 9.00038C16.3042 9.01546 15.9809 9.36324 15.9959 9.77718C15.9986 9.85109 16 9.92537 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10Z',
);
